export const PRIORITIES = ['Low', 'Medium', 'High', 'Critical'];
export const STATUSES = ['Not Started', 'In Progress', 'Blocked', 'Completed', 'Not Applicable'];

export const PRIORITY_STYLES = {
  Low: 'bg-slate-100 text-slate-700 border-slate-200',
  Medium: 'bg-sky-100 text-sky-800 border-sky-200',
  High: 'bg-amber-100 text-amber-800 border-amber-200',
  Critical: 'bg-rose-100 text-rose-800 border-rose-200',
};

export const STATUS_STYLES = {
  'Not Started': 'bg-slate-100 text-slate-600 border-slate-200',
  'In Progress': 'bg-blue-100 text-blue-800 border-blue-200',
  Blocked: 'bg-rose-100 text-rose-800 border-rose-200',
  Completed: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  'Not Applicable': 'bg-zinc-100 text-zinc-500 border-zinc-200 line-through',
};

export const PHASE_META = {
  'Foundation Setup': { tint: 'text-indigo-700', dot: 'bg-indigo-500' },
  Automation: { tint: 'text-violet-700', dot: 'bg-violet-500' },
  'Operational Control': { tint: 'text-cyan-700', dot: 'bg-cyan-500' },
  'Historical Data': { tint: 'text-amber-700', dot: 'bg-amber-500' },
  Testing: { tint: 'text-fuchsia-700', dot: 'bg-fuchsia-500' },
  'Pre-Cutover Plan': { tint: 'text-orange-700', dot: 'bg-orange-500' },
  Cutover: { tint: 'text-emerald-700', dot: 'bg-emerald-500' },
  Custom: { tint: 'text-slate-700', dot: 'bg-slate-500' },
};

export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    const dt = new Date(d.length <= 10 ? d + 'T00:00:00' : d);
    return dt.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return d;
  }
};
